export default "__VITE_ASSET__C6Rg$qvD__"